module.exports = __webpack_public_path__ + "images/agro04-10e7a57a4022b5c49fdbabb9ed4bce8f.jpeg";


//////////////////
// WEBPACK FOOTER
// ./app/frontend/images/agro04.jpeg
// module id = 225
// module chunks = 0